import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from '../../../app/LanguageContext';

export default function ConsignmentAllocateDialog({ open, onClose, onConfirm, loading }) {
  const { translate } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{translate('consignment.allocate_title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{translate('consignment.allocate_confirm_message')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>{translate('common.cancel')}</Button>
        <Button variant="contained" onClick={onConfirm} disabled={loading}>
          {translate('consignment.allocate_confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
